module.exports = __webpack_public_path__ + "static/media/4.ecd3c5e8.jpg";